import React from 'react';

interface FileContentRendererProps {
  file: {
    file_id: string;
    file_name: string;
    file_type: string;
    file_size: number;
    // Prefer backend-provided view_url for any viewing/preview, fall back to file_url for legacy data
    view_url?: string;
    file_url?: string;
    file_path?: string; // backend-internal; do not use to build URLs on FE
  };
  type: string;
}

export const FileContentRenderer: React.FC<FileContentRendererProps> = ({ file, type }) => {
  const getFileIcon = (fileType: string) => {
    switch (fileType.toLowerCase()) {
      case 'pdf':
        return '📄';
      case 'image':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return '🖼️';
      case 'video':
      case 'mp4':
      case 'avi':
      case 'mov':
        return '🎥';
      case 'audio':
      case 'mp3':
      case 'wav':
        return '🎵';
      default:
        return '📁';
    }
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className="text-center">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 mb-4">
        <div className="text-4xl mb-4">{getFileIcon(file.file_type)}</div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          {file.file_name}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          {file.file_type.toUpperCase()} • {formatFileSize(file.file_size)}
        </p>
        <a
          href={file.view_url || file.file_url || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Tải xuống
        </a>
      </div>
    </div>
  );
};
